// @ts-nocheck

import { Target } from '../client';
import { NAVBAR_BASE_HEIGHT } from '../constants/ui/navbar';
import { TABBAR_BASE_HEIGHT } from '../constants/ui/tabbar';

export const getFontSize = (ratio: number): number => {
  // for screen whose device pixel ratio is greater than 1, we set the font size to `15px` otherwise
  // ...the value is `12px`
  const baseFontSize = window.devicePixelRatio > 1 ? 15 : 14;
  return (Target.__MOBILE__ && (ratio * 20) >> 0) || baseFontSize;
};

export type SafeAreaInsetValue = {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
};

export const getSafeAreaInset = (domNode: HTMLElement): SafeAreaInsetValue => {
  const { paddingTop, paddingBottom, paddingLeft, paddingRight } = window.getComputedStyle(domNode);

  return {
    top: parseInt(paddingTop, 10),
    bottom: parseInt(paddingBottom, 10),
    left: parseInt(paddingLeft, 10),
    right: parseInt(paddingRight, 10),
  };
};

type AppBarHeightValue = {
  navbarHeight: number;
  tabbarHeight: number;
};

export const getAppBarHeight = (fontSize: number, safeAreaInset: SafeAreaInsetValue): AppBarHeightValue => {
  const navbarHeight = NAVBAR_BASE_HEIGHT * fontSize + safeAreaInset.top;
  const tabbarHeight = TABBAR_BASE_HEIGHT * fontSize + safeAreaInset.bottom;

  return { navbarHeight, tabbarHeight };
};

export const computeAppBarHeight = (ratio: number, domNode: HTMLElement): AppBarHeightValue => {
  const fontSize = getFontSize(ratio);
  const safeAreaInset = getSafeAreaInset(domNode);

  return getAppBarHeight(fontSize, safeAreaInset);
};
